import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Tap1 from '../../images/Tap1.webp';
import styles from './ImportantDates.module.css';

const importantDates = [
    { date: "August 17, 2026", event: "First day of classes" },
    { date: "September 7, 2026", event: "Labor Day (No classes!)" },
    { date: "October 26 – 31, 2026", event: "Costume Week" },
    // { date: "October 31, 2024", event: "Studio Closed! (No classes!)" },
    { date: "November 25 – 28, 2026", event: "Thanksgiving Holiday (No classes!)" },
    { date: "December 14 – 19, 2026", event: "Winter Dance Performances (In Studio)" },
    { date: "December 21, 2026 – January 3, 2027", event: "Winter Holiday (No classes!)" },
    { date: "January 4, 2027", event: "Classes Resume" },
    { date: "May 22, 2027", event: "Last Day Classes" },
    { date: "June 7, 2026", event: "First day of summer classes" },
];

const ImportantDates = () => {
    const navigate = useNavigate();
    const datesRef = useRef(null);
    const datesInView = useInView(datesRef, { triggerOnce: true });

    const handleBackClick = () => {
        navigate('/');
    };

    return (
        <div className={styles.datesContainer}>
            <button onClick={handleBackClick} className={styles.backButton}>BACK</button>
            <motion.div
                ref={datesRef}
                initial={{ opacity: 0 }}
                animate={{ opacity: datesInView ? 1 : 0 }}
                transition={{ duration: 0.8 }}
                className={styles.childContainer}
            >
                <div className={styles.textContainer}>
                    <h2 className={styles.datesTitle}>IMPORTANT DATES</h2>
                    <div className={styles.datesListContainer}>
                        <ul className={styles.datesList}>
                            {importantDates.map((item, index) => (
                                <li key={index} className={styles.dateItem}>
                                    <span className={styles.date}>{item.date}</span>
                                    <span className={styles.event}>{item.event}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className={styles.footerNote}>
                        <p>Calendar fall camps/drop-in events pop-ups/workshops (follow on social media)/summer session/camps</p>
                    </div>
                </div>
                <div className={styles.imageContainer}>
                    <img src={Tap1} alt="Ballet" className={styles.datesImage} />
                </div>
            </motion.div>
        </div>
    );
};

export default ImportantDates;
